/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";

import product1 from "assets/images/product1.jpg"
import product2 from "assets/images/product2.jpg"
import product3 from "assets/images/product3.jpg"

function LastSales() {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Last Sales
        </MDTypography>
        <MDBox mt={0} mb={2}>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <MDTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon sx={{ color: ({ palette: { success } }) => success.main }}>arrow_upward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant="button" color="text" fontWeight="medium">
              24%
            </MDTypography>{" "}
            this month
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox p={2}>
        <TimelineItem
          color="#F1F2F7"
          pic={product1}
          title="FAUX SUEDE PUFFER JACKET"
          description="Discount 10%"
          dateTime="14/12/23 12:23"
        />
        <TimelineItem
          color="#F1F2F7"
          pic={product2}
          title="KNIT HOODIE"
          description="Discount 20%"
          dateTime="14/12/23 12:04"
        />
        <TimelineItem
          color="#F1F2F7"
          pic={product3}
          title="LONG PUFFER JACKET"
          description="Discount 40%"
          dateTime="14/12/23 11:57"
          lastItem
        />
      </MDBox>
    </Card>
  );
}

export default LastSales;
